module.exports = __webpack_public_path__ + "img/prusa_add_filament_change.6cc6818b.gif";